import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AppThunk } from '../store';
import { firestore } from '../firebase';

import {
  AdRewardStats,
  ChatStats,
  InAppProductStats,
  MatchStats,
  MessageStats,
  PhotoStats,
  StatsData,
  SwipeStats,
  UserStats,
  WalletStats,
} from '../types/stats';


const statsInternal: any = {};

const calculateSum = () => {
  const result: any = {};

  for (const key in statsInternal) {
    const sum: any = {};
    for (const id in statsInternal[ key ]) {
      const data = statsInternal[ key ][ id ];
      for (const field in data) {
        if (typeof data[ field ] === 'string') {
          sum[ field ] = data[ field ];
        }
        else {
          sum[ field ] = (sum[ field ] ?? 0) + data[ field ];
        }
      }
    }

    result[ key ] = { ...sum };
  }

  return result;
}


interface StatsState {
  initDone: boolean;
  loading: boolean;
  users?: UserStats;
  photos?: PhotoStats;
  chats?: ChatStats;
  messages?: MessageStats;
  matches?: MatchStats;
  swipes?: SwipeStats;
  wallet?: WalletStats;
  ad_rewards?: AdRewardStats;
  in_app_products?: InAppProductStats;
}

const initialState: StatsState = {
  loading: false,
  initDone: false,
}



const service = createSlice({
  name: 'stats',
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>): StatsState {
      return { ...state, loading: action.payload, }
    },
    setInitDone(state, action: PayloadAction<boolean>): StatsState {
      return { ...state, initDone: action.payload, }
    },
    updateStats(state, action: PayloadAction<any>): StatsState {
      const newStats = {
        ...state,
        ...action.payload,
      }
      return newStats;
    },
  }
});


const init = (): AppThunk => async (dispatch, getState) => {

  const initDone = getState().stats.initDone;

  if (initDone) {
    return;
  }

  dispatch(service.actions.setLoading(true));

  let query = firestore.collection('stats');


  return query.onSnapshot({
    next: (snapshot) => {
      snapshot.docChanges().forEach(doc => {

        if (doc.type === 'removed') {
          return;
        }

        const updates = doc.doc.data() as StatsData;
        if (!statsInternal[ updates.key ]) {
          statsInternal[ updates.key ] = {};
        }
        statsInternal[ updates.key ][ doc.doc.id ] = updates;

      });

      
      const sum = calculateSum();
      dispatch(service.actions.updateStats(sum));





      if (!initDone) {
        dispatch(service.actions.setLoading(false));
        dispatch(service.actions.setInitDone(true));
      }
    },
    error: (err) => {
      console.error(err);
    }
  })
}


export const actions = {
  init
}

export default service.reducer;